export const ACCOUNT_TYPE = {
    SUPER_ADMIN: "SuperAdmin",
    ADMIN: "Admin",
    EMPLOYEE: "Employee",
    USER: "User",
  }
  
  export const NODE_STATUS = {
    DRAFT: "Draft",
    PUBLISHED: "Published",
  }